import React from "react";
import Card from "../../components/ConfigurationCards";
import Paper from "@material-ui/core/Paper";
import {
  GeneralContainer,
  CardsWrapper,
  FilterWrapper,
  SearchField,
} from "./GameManagerTabs.styled";
import { Form } from "react-bootstrap";
import SearchIcon from "@material-ui/icons/Search";
import { AntTab, AntTabs } from "../../helpers/antTabs";
import { theme as themeConfig } from "../../themes/themes";

const GameManagerTabs = ({
  selectedMenu,
  setFormTrigger,
  selectMenu,
  setValueTabs,
  valueTabs,
  searchTxt,
  setSearchTxt,
  renderAgain,
  setrenderAgain,
}) => {
  let goToMyGames = () => {
    selectMenu(["mygames", "My Games"]);
    setValueTabs(0);
  };

  let showSelectedTab = (selected) => {
    if (selected === "mygames") {
      return (
        <Card
          iconplusactive={false}
          coloricon={themeConfig.neutral.white}
          colorBorder={themeConfig.neutral.white}
          icon="plus"
          code="mygames"
          title="Create game"
          subtitle="game creation"
          footerText="Create new Game now"
          setFormTrigger={setFormTrigger}
        />
      );
    }
  };

  return (
    <>
      <GeneralContainer>
        <Paper position="static">
          <AntTabs aria-label="Games Management" value={valueTabs}>
            <div>
              <AntTab
                label="New Game"
                id="mygames"
                valueTabs={valueTabs}
                onClick={() => goToMyGames()}
              />
            </div>
          </AntTabs>
        </Paper>

        <CardsWrapper className="pt-3 pb-2">
          {showSelectedTab(selectedMenu[0])}
          <FilterWrapper>
            <SearchField>
              <SearchIcon />
              <Form.Control
                type="text"
                placeholder="Search"
                value={searchTxt}
                onChange={(e) => {
                  setSearchTxt(e.target.value);
                }}
                onBlur={() => setrenderAgain(!renderAgain)}
              />
            </SearchField>
          </FilterWrapper>
        </CardsWrapper>
      </GeneralContainer>
    </>
  );
};

export default GameManagerTabs;
